import { h } from 'preact'

export const EditoTv = ({ image, imageLandscape, alt, title, description, CTA, target, darkmode, analytics, cacheKey }) => (
   <section
      id="zone_reassurance_chainestv"
      class={`edito-tv lien-composite mb-2 mb-md-4 ${darkmode ? 'bg-dark' : ''}`}
      data-testid="bande-edito-tv"
      data-cache-key={cacheKey}
      data-pdb-zid={analytics.pdbZid}
      data-pdb-sc={analytics.pdbSc}
      data-pdb-idc={analytics.pdbIdc}
      data-pdb-vi={analytics.pdbVi}
      data-oevent-category={analytics.oeventCategory}
      data-oevent-action={analytics.oeventAction}
      data-oevent-label={analytics.oeventLabel}
      data-oevent-other={analytics.oeventOther}
   >
      <picture>
         <source srcset={`${image}?format=480x320&saveas=webp`} media="(max-width: 479px)" />
         <source srcset={`${imageLandscape}?format=x180&saveas=webp`} media="(max-width: 599px) and (orientation: landscape)" />
         <source srcset={`${imageLandscape}?format=x270&saveas=webp`} media="(max-width: 959px) and (orientation: landscape)" />
         <source srcset={`${image}?format=1200x360&saveas=webp`} media="(max-width: 1199px)" />
         <img loading="lazy" src={`${image}?format=1440x450&crop=1440,450,0,0&saveas=webp`} alt={alt} class="img" />
      </picture>
      <div class="edito-tv-content container-fluid">
         <div class="row">
            <div class="col-6 col-lg-4 col-xl-3 bloc-title">
               <h2 class={`h3 pb-0 pb-md-1 mb-0 ${darkmode ? 'text-white' : ''}`}>{title}</h2>
            </div>
         </div>
         <div class="row">
            <div class="col-7 col-lg-5 col-xl-4 bloc-text">
               <p class={`lead mb-xl-2 ${darkmode ? 'text-white' : 'text-muted'}`}>{description}</p>
               <a href={CTA.URL} target={CTA.target === '_blank' ? '_blank' : ''} class={`btn btn-secondary ${darkmode ? 'btn-inverse' : ''}`}>
                  {CTA.label}
               </a>
            </div>
         </div>
      </div>
   </section>
)
